export default "__VITE_ASSET__DcVfpU4X__"